import DocumentTypesTable from './DocumentTypesTable';
import DocumentTypeModal from './DocumentTypeModal';
import Pagination from '../../../shared/Pagination';
import ConfirmDialog from '../../../shared/ConfirmDialog';
import SuccessDialog from '../../../shared/SuccessDialog';
import ListPageSection from '../../../shared/ListPageSection';
import { useListFilters } from '../../../../hooks/shared/useListFilters';
import { useCrudModals } from '../../../../hooks/shared/useCrudModals';
import { useDocumentTypes } from '../../../../hooks/admin/edmsSettings/documentTypes/useDocumentTypes';
import { useDocumentTypeMutations } from '../../../../hooks/admin/edmsSettings/documentTypes/useDocumentTypeMutations';
import {
  PAGE,
  ACTIONS,
  SEARCH,
  ACTIVE_FILTER,
  MESSAGES,
  CONFIRM,
  SUCCESS_DIALOG,
} from './DocumentTypesConstants';

const PAGE_SIZE = 10;

const DocumentTypesPage = () => {
  const listFilters = useListFilters(PAGE_SIZE);
  const { filters, activeState, setActiveState, setPage, search, setSearch, setPageToOne } =
    listFilters;

  const { data, pagination, isLoading, isFetching, isError, error } = useDocumentTypes(filters, {
    enabled: true,
  });

  const { createMutation, updateMutation, deleteMutation } = useDocumentTypeMutations();

  const crud = useCrudModals({
    createMutation,
    updateMutation,
    deleteMutation,
    getItemId: (item) => item._id,
    getItemName: (item) => item.name ?? '',
    messages: MESSAGES,
  });

  const { form, confirm, success, deletingId, deleteMutation: deleteMut, handleDeleteRequest } =
    crud;

  const confirmTitle = confirm.type === 'delete' ? CONFIRM.deleteTitle : CONFIRM.updateTitle;
  const confirmMessage =
    confirm.type === 'delete' ? CONFIRM.deleteMessage(confirm.data?.name) : CONFIRM.updateMessage;
  const confirmText = confirm.type === 'delete' ? ACTIONS.delete : ACTIONS.edit;
  const successTitle =
    success.variant === 'error' ? SUCCESS_DIALOG.errorTitle : SUCCESS_DIALOG.successTitle;

  return (
    <>
      <div className="rounded-2xl border border-cream/60 bg-white shadow-sm">
        <ListPageSection
          title={PAGE.title}
          description={PAGE.description}
          activeState={activeState}
          onActiveChange={setActiveState}
          search={search}
          onSearchChange={setSearch}
          searchPlaceholder={SEARCH.placeholder}
          onFilterChange={setPageToOne}
          activeSelectId={ACTIVE_FILTER.selectId}
          searchInputId={SEARCH.inputId}
          primaryAction={{
            label: ACTIONS.create,
            onClick: form.openCreateModal,
            disabled: form.isSubmitting,
          }}
        >
          <DocumentTypesTable
            data={data}
            isLoading={isLoading}
            isFetching={isFetching}
            isError={isError}
            error={error}
            onEdit={form.openEditModal}
            onDelete={handleDeleteRequest}
            isBusy={form.isSubmitting || deleteMut.isPending}
            deletingId={deletingId}
          />
          <Pagination pagination={pagination} onPageChange={(newPage) => setPage(newPage)} />
        </ListPageSection>

        <DocumentTypeModal
          isOpen={form.isFormOpen}
          mode={form.formMode}
          documentType={form.selectedItem}
          onSubmit={form.handleSubmitForm}
          onClose={form.handleCloseForm}
          isSubmitting={form.isSubmitting}
          serverError={form.formError}
        />

        <ConfirmDialog
          isOpen={confirm.isOpen}
          title={confirmTitle}
          message={confirmMessage}
          confirmText={confirmText}
          cancelText={ACTIONS.cancel}
          onConfirm={confirm.onConfirm}
          onCancel={confirm.onCancel}
          isLoading={confirm.isLoading}
        />

        <SuccessDialog
          isOpen={success.isOpen}
          title={successTitle}
          message={success.message}
          onClose={success.onClose}
          variant={success.variant}
        />
      </div>
    </>
  );
};

export default DocumentTypesPage;
